export const inspectionsConstants = {
  INSPECTIONS_UPLOADING: '[Inspections] Uploading',
  INSPECTIONS_UPLOADING_SUCCESS: '[Inspections] Uploading success',
  LOADING_INSPECTIONS: '[Inspections] Loading inspections',
  LOADING_INSPECTIONS_SUCCESS: '[Inspections] Loading inspections success',
  LOADING_INSPECTIONS_FAILURE: '[Inspections] Loading inspections failure'
}
